import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, CircleIcon } from 'lucide-react';
const rules = [{
  id: 1,
  text: 'Mesaje clare și concise – începe cu subiectul problemei'
}, {
  id: 2,
  text: 'Răspunde rapid la solicitările echipei'
}, {
  id: 3,
  text: 'Evită discuțiile neproductive – menține profesionalismul'
}, {
  id: 4,
  text: 'Anunță orice absență (personală sau concediu)'
}, {
  id: 5,
  text: 'Folosește grupul doar pentru comunicare de serviciu'
}];
export function CommunicationChecklist() {
  const [checkedItems, setCheckedItems] = useState<number[]>([]);
  const toggleItem = (id: number) => {
    setCheckedItems(prev => prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]);
  };
  return <div className="space-y-4" data-id="element-661">
      {rules.map((rule, index) => <motion.button key={rule.id} initial={{
      opacity: 0,
      x: -20
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.4,
      delay: index * 0.1
    }} onClick={() => toggleItem(rule.id)} className="w-full flex items-start space-x-4 text-left p-5 rounded-xl bg-white shadow-md hover:shadow-lg transition-all border-2 border-transparent hover:border-[#21A366]" data-id="element-662">
          {checkedItems.includes(rule.id) ? <CheckCircleIcon className="w-6 h-6 flex-shrink-0 text-[#21A366]" data-id="element-663" /> : <CircleIcon className="w-6 h-6 flex-shrink-0 text-gray-300" data-id="element-664" />}
          <span className={`flex-1 ${checkedItems.includes(rule.id) ? 'text-[#21A366] font-medium' : 'text-gray-700'}`} data-id="element-665">
            {rule.text}
          </span>
        </motion.button>)}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="mt-6 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-xl" data-id="element-666">
        <p className="text-[#132C53] font-medium" data-id="element-667">
          ⚠️ Comunicarea constantă este cheia unui suport eficient.
        </p>
      </motion.div>
    </div>;
}